var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "all-container flex",
    class: {
      closeSide: !_vm.open,
      horizontal: _vm.horizontal
    }
  }, [!_vm.horizontal ? _c("side-bar", {
    staticClass: "aside-container",
    attrs: {
      collapsed: _vm.open
    }
  }) : _vm._e(), _c("div", {
    staticClass: "main-container",
    class: {
      hasTag: _vm.tagShow
    }
  }, [_c("div", {
    class: {
      "fixed-header": _vm.fixHeader
    }
  }, [!_vm.horizontal ? _c("nav-bar", {
    attrs: {
      collapsed: _vm.open
    }
  }) : _c("div", {
    staticClass: "horizontal-nav flex"
  }, [_c("horizontal-side"), _c("nav-bar", {
    staticClass: "nav-user",
    attrs: {
      horizontal: _vm.horizontal
    }
  })], 1), _vm.tagShow ? _c("tag-view") : _vm._e()], 1), _c("div", {
    staticClass: "rightPanl fixed pointer",
    on: {
      click: _vm.changeVisivle
    }
  }, [_c("a-icon", {
    staticClass: "settingIcon",
    attrs: {
      type: "setting"
    }
  }), _c("setting")], 1), _c("div", {
    staticClass: "app-main"
  }, [_c("router-view"), _c("back-top")], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };